import {
  Card,
  CardBody,
  Input,
  Table,
  TableCell,
  TableContainer,
  TableHeader,
  Button,
} from "@windmill/react-ui";
import ExportDataXlsx from "components/common/ExportDataXlsx";
import VehicleModelTable from "components/vehicleCategory/VehicleModelTable";
import NotFound from "components/table/NotFound";
import PageTitle from "components/Typography/PageTitle";
import { SidebarContext } from "context/SidebarContext";
import useAsync from "hooks/useAsync";
import useFilter from "hooks/useFilter";
import { useState, useContext, useEffect } from "react";
import Somethingwentwrong from "pages/Somethingwentwrong";
import VehicleCategoryServices from "services/VehicleCategoryServices";
import { FiPlus } from "react-icons/fi";
import VehicleModelDrawer from "components/drawer/VehicleModelDrawer";
import MainDrawer from "components/drawer/MainDrawer";
import DeleteModal from "components/modal/DeleteModal";
import useToggleDrawer from "hooks/useToggleDrawer";
import sidebar from "routes/sidebar";
import DataWrapper from "./DataWrapper";
import { FiRefreshCcw } from "react-icons/fi";

const VehicleCategory = () => {
  const adminInfo = localStorage.getItem("adminInfo")
    ? JSON.parse(localStorage.getItem("adminInfo"))
    : null;
  const { toggleDrawer, setIsUpdate } = useContext(SidebarContext);
  const { title, serviceId } = useToggleDrawer();
  const [status, setStatus] = useState("");
  const { data, loading, error } = useAsync(
    VehicleCategoryServices.getAllVehicleCategory,
  );

  const isAdmin = adminInfo?.id === 1;

  const hideView = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "vehicle type" && perm.view === 1,
      );

  const hideDelete = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "vehicle type" && perm.delete === 1,
      );

  const hideEdit = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "vehicle type" && perm.edit === 1,
      );

  const hideAdd = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "vehicle type" && perm.add === 1,
      );

  const hideExport = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "vehicle type" && perm.export === 1,
      );

  const [itemsPerPage, setItemsPerPage] = useState(10);
  const {
    vehicleCategoryRef,
    dataTable,
    serviceData,
    handleSubmitVehicleCategory,
    currentPage,
  } = useFilter(Array.isArray(data.data) ? data.data : [], itemsPerPage);

  useEffect(() => {
    if (data?.status) {
      setStatus(data.status);
    } else {
      setStatus(false);
    }
  }, [data?.status]);

  useEffect(() => {
    if (serviceData.length !== 0) {
      setItemsPerPage(serviceData.length);
    }
  }, [serviceData]);
  const amenitiesMapping = {
    1: "AC",
    2: "Charger",
    3: "Music",
    4: "Carrier",
    5: "TV",
  };

  const updatedData = data?.data?.map((item, index) => {
    return {
      "SI.No": index + 1,
      "Vehicle Category": item?.vehicle_type_name || "-",
      Similar:
        item?.vehicle_names?.length > 0
          ? item.vehicle_names.map((name) => name || "-").join(", ")
          : "-",

      Seats: item?.seats ?? "-",
      "Large Bags": item?.no_of_bags ?? "-",
      "Small Bags": item?.no_of_small_bags ?? "-",
    };
  });

  const handleRefresh = () => {
    setIsUpdate(true);
  };
  return (
    <>
      {hideView && (
        <>
          <DeleteModal id={serviceId} title={title} />

          <MainDrawer>
            <VehicleModelDrawer id={serviceId} />
          </MainDrawer>

          <PageTitle sidebar={sidebar().sidebar} />

          <Card className="min-w-0 shadow-xs overflow-hidden bg-white dark:bg-gray-800 mb-5">
            <CardBody>
              <div className="flex gap-6 items-center">
                <div className="flex-1">
                  <Input
                    ref={vehicleCategoryRef}
                    className="border h-10 text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"
                    type="search"
                    name="search"
                    autoComplete="off"
                    placeholder="Quick Search"
                    onChange={handleSubmitVehicleCategory}
                  />
                </div>

                {hideAdd && (
                  <Button
                    onClick={toggleDrawer}
                    className="w-56 rounded-md h-10"
                  >
                    <span className="mr-3">
                      <FiPlus />
                    </span>
                    Add Vehicle Category
                  </Button>
                )}

                {hideExport && (
                  <ExportDataXlsx
                    exportDataXlsx={updatedData}
                    fileNames="Vehicle Category"
                  />
                )}

                <FiRefreshCcw
                  onClick={() => {
                    handleRefresh();
                  }}
                  cursor="pointer"
                />
              </div>
            </CardBody>
          </Card>

          <DataWrapper loading={loading} error={error} status={status}>
            {serviceData?.length !== 0 ? (
              <TableContainer>
                <div
                  className="overflow-y-scroll"
                  style={{ maxHeight: "67vh", scrollbarWidth: "thin" }}
                >
                  <Table>
                    <TableHeader className="capitalize text-center z-10 sticky top-0">
                      <tr>
                        <TableCell>Sl.No.</TableCell>
                        <TableCell>Vehicle Category</TableCell>
                        <TableCell>Similar</TableCell>
                        <TableCell>Seats</TableCell>
                        <TableCell>Large Bags</TableCell>
                        <TableCell>Small Bags</TableCell>
                        <TableCell>Image</TableCell>
                        <TableCell>Prime Image</TableCell>
                        <TableCell>Actions</TableCell>
                      </tr>
                    </TableHeader>
                    <VehicleModelTable
                      vehicleCategory={dataTable}
                      perpage={itemsPerPage}
                      currentPage={currentPage}
                      hideEdit={hideEdit}
                      hideDelete={hideDelete}
                    />
                  </Table>
                </div>
              </TableContainer>
            ) : (
              <>
                {data.status !== true ? (
                  <Somethingwentwrong title="Something Went Wrong, Try After Sometime" />
                ) : (
                  <NotFound title="There are no Vehicle Type." />
                )}
              </>
            )}
          </DataWrapper>
        </>
      )}
    </>
  );
};

export default VehicleCategory;
